import oddOneOutContent from '@/assets/odd_one_out.json'

const TOPIC_ALIASES = {
  'house-furniture': 'house-and-furniture',
}

const ASSETS_HOST = 'https://gru-games.s3.eu-west-2.amazonaws.com'

const normalizeTopicKey = (key) => {
  if (!key) {
    return undefined
  }
  return TOPIC_ALIASES[key] || key
}

const resolveImage = (imgPath) => {
  if (!imgPath) {
    return null
  }
  // Input already contains `/assets/...` paths so just prepend host.
  return `${ASSETS_HOST}${imgPath}`
}

export const getCardsForTopic = async (contentKey) => {
  // Split by '__' to extract game prefix and topic key (e.g., "odd_one_out__animals")
  // If no '__' found, assume it's just the topic key for backward compatibility
  let topicKey = contentKey
  if (contentKey.includes('__')) {
    const [gameKey, actualTopicKey] = contentKey.split('__')
    if (gameKey !== 'odd_one_out') {
      throw new Error(`Invalid game key: "${gameKey}". Expected "odd_one_out"`)
    }
    topicKey = actualTopicKey
  }

  const normalizedKey = normalizeTopicKey(topicKey)
  if (!normalizedKey) {
    throw new Error('Topic key is required')
  }

  const { content, settings } = oddOneOutContent
  const topicContent = content[normalizedKey]

  if (!topicContent) {
    throw new Error(`Topic "${topicKey}" not found`)
  }

  const enrichedContent = topicContent.map((item) => ({
    cards: item.cards.map((card) => ({
      text: card.text,
      img: resolveImage(card.img),
    })),
    oddOneOut: {
      text: item.oddOneOut.text,
      img: resolveImage(item.oddOneOut.img),
    },
    reason: item.reason,
    isPronunciation: normalizedKey === 'pronunciation',
  }))

  return {
    isFreeTopic: settings?.freeTopics?.includes(normalizedKey),
    content: enrichedContent,
  }
}
